import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlTabClassificacao = '/service/materiais/almoxarifado/classificacao/'

class ClassificacaoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    getClassificacao() {
        return this.conex.get(urlTabClassificacao + 'recuperaClassificacaoBemImovel/')
    }
}

export default ClassificacaoService
